import { useForm, SubmitHandler } from "react-hook-form";
import { Button } from "@mui/material";
import { Link, useNavigate, useLocation } from "react-router-dom";
import styles from "./ProductEditor.module.css";
import { ProductRegisterData } from "./ProductRegister"
import { useEffect, useState,useContext,useMemo } from "react";
import { baseUrl } from "../../url";
import { AuthContext, AuthContextType } from "../../Auth";

export default function ProductEditor() {

    const navigate = useNavigate();
    const location = useLocation();
    const editData = location.state;
    console.log(editData);

    const LeftRight = (editData.leftright[0] === "") ? '[""]' : '["左","右"]';
    const LeftRight2 = (editData.leftright[0] === "") ? '["左","右"]' : '[""]';
    const LeftRight3 = (editData.leftright[0] === "") ? "左右無し" : "左右有り";
    const LeftRight4 = (editData.leftright[0] === "") ? "左右有り" : "左右無し";
    const editSize = useMemo(() => {
        return editData.size.join(',');
    }, [editData.size]);

    const editColor = useMemo(() => {
        return editData.color.join(',');
    }, [editData.color]);

    const initialvalues = useMemo(() => ({
        productname: editData.productname,
        manufacture: editData.manufacture,
        supplier: editData.supplier,
        moldingsite: editData.moldingsite,
        cost: editData.cost,
        leftright: LeftRight,
        size: editSize,
        color: editColor,
        product_type: editData.product_type,
        base_price: editData.base_price
    }), [editData.productname, editData.manufacture, editData.supplier, editData.moldingsite, editData.cost, LeftRight, editSize, editColor, editData.product_type , editData.base_price]);

    const [suppliers, setSuppliers] = useState<string[]>();
    const [manufactures, setManufactures] = useState<string[]>();
    const [moldingsite, setMoldingsite] = useState<string[]>();
    const { setAuth } = useContext(AuthContext) as AuthContextType;
    console.log(initialvalues.leftright);



 useEffect(() => {
        const checkAuth = async () => {
            try {
                const response = await fetch(`${baseUrl}/checkAuth`, {
                    method: "POST",
                    credentials: "include",
                    headers: { 'Content-Type': 'application/json' },
                });
                const data = await response.json();
                if (!data.result) {
                    console.log("Not authenticated");
                    setAuth({ username: null, isAuthenticated: false, office: undefined, authority:"user" });
                    return navigate("/login");
                }
                 const response2 = await fetch(`${baseUrl}/getusersdata`,{
                        method: "POST",
                        credentials: "include",
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify({ username: data.username })
                    })
                    const data2 = await response2.json();
                    console.log("Authenticated user:", data.username, "Office:", data2.office,"Authority:",data2.authority);
                    setAuth({ username: data.username, isAuthenticated: true, office: data2.office,authority:data2.authority });
            } catch (error) {
                console.error(error);
            }
        }
        checkAuth();
    }, [navigate, setAuth]);

    useEffect(() => {
        const fetchSupplier = async () => {
            const response = await fetch(`${baseUrl}/getsupplier`,{
                method: "GET",
                credentials: "include",
            })
            const data = await response.json();
            if(data.isAuth===false){
            return 
        }
            let suppliername: string[] = [];
            for (let i = 0; i < data.length; i++) {
                suppliername = [...suppliername, data[i].supplier]
            }
            const newSupplierName = suppliername.filter(value => {
                return initialvalues.supplier !== value
            })
            setSuppliers(newSupplierName);
        }

        const fetchmoldingsite = async () => {
            const response = await fetch(`${baseUrl}/moldingsite`, {
                method: "GET",
                credentials: "include",
            });
            const data = await response.json();
            if(data.isAuth===false){
            return 
        }
            const newMoldingsite = data.filter((value: string) => {
                return initialvalues.moldingsite !== value;
            })
            setMoldingsite(newMoldingsite);
        }

        const fetchManufacture = async () => {
            const response = await fetch(`${baseUrl}/getmanufacture`,{
                method: "GET",
                credentials: "include",
            });
            const data = await response.json();
            if(data.isAuth===false){
            alert("セッションが切れました。再度ログインしてください");
            setAuth({ username: null, isAuthenticated: false, office: undefined, authority:"user" });
            return navigate("/login");}
            const Manufacture = data.manufacture.map((item: Object) => Object.values(item));
            const newManufacture = Manufacture.filter((value: string) => {
                return initialvalues.manufacture !== value;
            })
            setManufactures(newManufacture);
        }

        fetchSupplier();
        fetchmoldingsite();
        fetchManufacture();
    }, [initialvalues.manufacture, initialvalues.moldingsite, initialvalues.supplier, navigate, setAuth])


    const {
        register,
        handleSubmit,
        watch,
        formState: { errors },
    } = useForm<ProductRegisterData>(
        {
            mode: 'onBlur',
            defaultValues: initialvalues
        }
    )

const selectedProductType= watch("product_type");

    const onSubmit: SubmitHandler<ProductRegisterData> = async (data) => {
        const idplus = { ...data, product_id: editData.product_id }
        const datastr = JSON.stringify(idplus);
        const response = await fetch(`${baseUrl}/updateProduct`, {
            method: "PUT",
            credentials: "include",
            headers: { 'Content-Type': 'application/json' },
            body: datastr
        })
        const resjson = await response.json();
        if(resjson.isAuth===false){
            alert("セッションが切れました。再度ログインしてください");
            setAuth({ username: null, isAuthenticated: false, office: undefined, authority:"user" });
            return navigate("/login");}
        alert(resjson.message);
        if (resjson.submit) {
            navigate("/Products");
        }
    }

    return (

        <form className={styles.form} onSubmit={handleSubmit(onSubmit)}>
            <h2>製品の登録</h2>
            <p>すべての項目を入力してください。</p>
            <p>製品の名称を入力してください。<br />
                （全角で入力してください。）</p>
            <input type="text"
                {...register("productname",
                    {
                        required: "製品の名称は必須です。",
                        maxLength: {
                            value: 50, message: "50文字以内で入力してください。"
                        },
                        pattern: { value: /^[Ａ-ＺＡ-ｚ\u4E00-\u9FFFぁ-んァ-ヶ０-９ー・　]+$/, message: "全角で入力してください。" },
                    })} className={styles.input} />
            <span>{errors.productname?.message}</span>

            <p className={styles.p}>製品の取り扱いを選択してください。</p>
                        <select {...register("product_type", { required: "製品の取り扱いの名称は必須です。" })} className={styles.select}>
                            <option value="">--選択--</option>
                            <option value="list">リスト内既製品</option>
                            <option value="readymade">リスト外既製品</option>
                            <option value="not_applicable">保険適用外（自費）製品</option>
                        </select>
                        <span>{errors.product_type?.message}</span>

                        {selectedProductType==="list" && <>
            <p className={styles.p}>リスト内既製品の基準価格を入力してください。<br />
                （半角数字で入力してください。）</p>
            <input type="number" {...register("base_price", {
                required: "リスト内既製品の場合、基準価格の入力は必須です。"
            })} className={styles.input} />
            <span>{errors.base_price?.message}</span></>
            }

            <p>製品のメーカー名を選択してください。</p>
            <select {...register("manufacture", { required: "メーカーの名称は必須です。" })} className={styles.select} >
                <option value={initialvalues.manufacture}> {initialvalues.manufacture}</option>
                {manufactures ? manufactures.map((item, index) => <option key={index} value={item}>{item}</option>) : null}
            </select>
            <span>{errors.manufacture?.message}</span>

            <p>製品の発注先を選択してください。</p>
            <select {...register("supplier", { required: "必ず選択してください。" })} className={styles.select}>
                <option value={initialvalues.supplier}>{initialvalues.supplier}</option>
                {suppliers ? suppliers.map((item, index) => (<option key={index} value={item}>{item}</option>)) : null}
            </select>
            <span>{errors.supplier?.message}</span>

            <p>製品の採型区分を選択してください。</p>
            <select {...register("moldingsite", { required: "必ず選択してください。" })} className={styles.select}>
                <option value={initialvalues.moldingsite}>{initialvalues.moldingsite}</option>
                {moldingsite ? moldingsite.map((item, index) => (<option key={index} value={item}>{item}</option>)) : null}
            </select>
            <span>{errors.moldingsite?.message}</span>

            <p>仕入れ値を入力してください。<br />
                （半角数字で入力してください。）</p>
            <input type="number" {...register("cost", {
                required: "仕入れ値は必須です。"
            })} className={styles.input} />
            <span>{errors.cost?.message}</span>
            <p>左右の有無を選択してください。</p>
            <select {...register("leftright")} className={styles.select}>
                <option value={LeftRight}>{LeftRight3}</option>
                <option value={LeftRight2}>{LeftRight4}</option>
            </select>
            <p>サイズを入力してください。サイズ区分がない場合は未入力で進んでください。<br />
                （半角の　,　で区切ってすべてのサイズを入力してください。<br />
                カナは全角、アルファベットと数字は半角で入力してください。）<br />
                例）S,M,L,LL   S,M-L,ショートS,ショートM-L　等</p>

            <input type="text"
                {...register("size",
                    {
                        maxLength: {
                            value: 50, message: "50字以内で表現してください。"
                        },
                        pattern: { value: /^[\u4E00-\u9FFFA-Zァ-ヶ0-9\-ー,]+$/, message: "アルファベットの大文字、全角カナ、半角数字で入力してください。" },
                    })} className={styles.input} />
            <span>{errors.size?.message}</span>
            <p>色を入力してください。色区分がない場合は未入力で進んでください。<br />
                （半角の　,　で区切ってすべてのサイズを入力してください。<br />
                全角カナか漢字で入力してください。）<br />
                例）ベージュ、ブラック 黒  等</p>

            <input type="text"
                {...register("color",
                    {
                        maxLength: {
                            value: 20, message: "20字以内で表現してください。"
                        },
                        pattern: {
                            value: /^[\u4E00-\u9FFFァ-ヶー,]+$/, message: "漢字か全角カタカナで入力してください。"
                        },
                    })} className={styles.input} />
            <span>{errors.color?.message}</span>

            <Button type="submit" variant="contained" style={{ margin: 15 }}>登録</Button>
            <Link to="/Products"><Button>キャンセル</Button></Link>
        </form>
    )
}